import { render, staticRenderFns } from "./SimpleNavApp.vue?vue&type=template&id=6c97bf1d&scoped=true&"
import script from "./SimpleNavApp.vue?vue&type=script&lang=js&"
export * from "./SimpleNavApp.vue?vue&type=script&lang=js&"
import style0 from "./SimpleNavApp.vue?vue&type=style&index=0&id=6c97bf1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c97bf1d",
  null
  
)

export default component.exports